import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {deleteReport, getReports, messageReset, editSaveReport, clearReports} from "../store/reports";
import Button from "@mui/material/Button";
import Header from "../blocks/header";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Dashboard from "../blocks/dashboard";
import Copyright from "../blocks/copyright";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import DeleteModal from "../blocks/deleteModal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import {FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Pagination, Select, Tab} from "@mui/material";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import {TabContext, TabList} from "@mui/lab";
import TabPanel from "@mui/lab/TabPanel";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const label = {inputProps: {'aria-label': 'Checkbox'}};
const PAGE_SIZE = 20

function Reports(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const regionId = params.id || false
    const toBack = () => navigate(-1)

    // Original bilan bir xil: tab default 'one'
    const [tab, setTab] = useState('one')

    // Tab → backend status ID moslik
    const STATUS_MAP = {one: 1, two: 2, three: 3, four: 4}
    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [year, setYear] = useState(new Date().getFullYear().toString())
    const [month, setMonth] = useState(1)
    const [search, setSearch] = useState('')
    const [fileIds, setFileIds] = useState([])
    const [page, setPage] = useState(1)

    function fetchData(pg, yr, mn, rid) {
        const _page = pg !== undefined ? pg : page
        const _year = yr !== undefined ? yr : year
        const _month = mn !== undefined ? mn : month
        const _rid = rid !== undefined ? rid : regionId
        props.getReports(_page, PAGE_SIZE, _year, _month, _rid || '')
    }

    useEffect(() => {
        // Original: token verify + data yuklash
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        if (!year || year == 1970) {
            setYear(new Date().getFullYear().toString())
        }
        fetchData(1)
    }, [])

    // Original: verify tekshiruvi
    useEffect(() => {
        if (props.verify === false) {
            navigate("/login/")
        }
    }, [props.verify])

    useEffect(() => {
        setFileIds([])
        setPage(1)
        props.clearReports()          // Eski data ko'rinmasin
        fetchData(1, year, month, STATUS_MAP[tab])
    }, [tab])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function ToFilter(e) {
        e.preventDefault()
        setPage(1)
        fetchData(1, year, month, STATUS_MAP[tab])
    }

    function saveFile() {
        if (!year || year == 1970) setYear(new Date().getFullYear().toString())
        if (fileIds.length > 0 || tab !== 'one') {
            const bodyFormData = new FormData()
            if (fileIds.length > 0) fileIds.forEach(id => bodyFormData.append("id_list", id))
            if (regionId) bodyFormData.append("region_id", regionId)
            if (tab !== 'one') {
                function tabId(val) {
                    switch (val) {
                        case 'two': return "2"
                        case 'three': return "3"
                        case 'four': return "4"
                        default: return "0"
                    }
                }
                bodyFormData.append("table_id", tabId(tab))
                bodyFormData.append("month", month.toString())
                if (typeof year != "string" || year == 1970) {
                    bodyFormData.append("year", new Date(year).getFullYear().toString())
                } else {
                    bodyFormData.append("year", year.toString())
                }
            }
            axios({url: 'https://ishlabchiqarish.uzkoj.uz/api/get-excel/', method: 'POST', data: bodyFormData, responseType: 'blob'})
                .then(response => {
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href; link.setAttribute('download', `hisobot_${Date.now()}.xlsx`)
                    document.body.appendChild(link); link.click()
                    document.body.removeChild(link); URL.revokeObjectURL(href)
                })
        } else {
            axios({url: 'https://ishlabchiqarish.uzkoj.uz/api/get-excel/', method: 'GET', responseType: 'blob'})
                .then(response => {
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href; link.setAttribute('download', `hisobot_${Date.now()}.xlsx`)
                    document.body.appendChild(link); link.click()
                    document.body.removeChild(link); URL.revokeObjectURL(href)
                })
        }
    }

    function allowResubmit(item) {
        axios({
            url: `https://ishlabchiqarish.uzkoj.uz/api/reports/${item.id}/allow-resubmit/`,
            method: 'POST',
            headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}`}
        }).then(() => {
            toast.success(t('resubmit_allowed'), {theme: 'colored'})
            fetchData()
        }).catch(() => toast.error(t('save_error'), {theme: 'colored'}))
    }

    function monthSelect(val) {
        switch (val) {
            case 1: return t('quarter')
            case 2: return t('semi_annual')
            case 3: return t('nine_month')
            case 4: return t('yearly')
            default: return ''
        }
    }

    function statusSelect(val) {
        switch (val) {
            case 1: return t('no_send')
            case 2: return t('review')
            case 3: return t('canceled')
            case 4: return t('accepted')
            default: return ''
        }
    }

    function fileId(value) {
        setFileIds(prev => {
            const index = prev.indexOf(value)
            if (index === -1) return [...prev, value]
            return prev.filter(id => id !== value)
        })
    }

    function toAdd() { navigate('/add-report/') }
    function toEdit(data) { navigate('/edit-report/' + data.id) }
    function toDelete(item) { setOpenItem(item); setOpen(true) }
    function toView(item) { navigate('/view-report/' + item.id) }

    const reports = props.reports || []

    function ReportTable({statusFilter}) {
        if (!reports.length) return <div className={'no-infos'}>{t('no_info')}</div>
        return (
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    {is_main && <th scope="col">{t('title_company')}</th>}
                    {is_main && <th scope="col">{t('year_plan_currently')}</th>}
                    {is_main && <th scope="col">{t('responsible_person')}</th>}
                    <th scope="col">{t('type')}</th>
                    <th scope="col">{t('report_year')}</th>
                    <th scope="col">{t('report_month')}</th>
                    <th scope="col">{t('status')}</th>
                    {is_main && <th scope="col">{t('report_sent_time')}</th>}
                    <th scope="col"/>
                </tr>
                </thead>
                <tbody>
                {reports.map((item, index) => (
                    <tr key={item.id}>
                        {is_main
                            ? <th scope="row">
                                <Checkbox
                                    checked={fileIds.includes(item.id)}
                                    onChange={() => fileId(item.id)}
                                    color="primary"
                                />
                            </th>
                            : <th scope="row">{index + 1}</th>}
                        {is_main && <td>{item.user?.user_name}</td>}
                        {is_main && <td>{item.year_plan_currently}</td>}
                        {is_main && <td>{item.responsible_person || '-'}</td>}
                        <td>{item.type === 1 ? t('type_report') : t('type_reply_report')}</td>
                        <td>{item.year}</td>
                        <td>{monthSelect(item.month)}</td>
                        <td>
                            <span className={'status' + item.status}>{statusSelect(item.status)}</span>
                            {(statusFilter === 2 || statusFilter === 3 || statusFilter === 4) &&
                                <><br/>{item.true_time ? t('true_time') : t('notrue_time')}</>}
                        </td>
                        {is_main && <td style={{whiteSpace: 'nowrap'}}>{item.created_time ? new Date(item.created_time).toLocaleString('ru-RU') : '-'}</td>}
                        <td>
                            <Button variant="contained" color="primary" endIcon={<VisibilityIcon/>}
                                    onClick={() => toView(item)}/>
                            {!item.is_send && <>
                                <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                        onClick={() => toEdit(item)}/>
                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                        onClick={() => toDelete(item)}/>
                            </>}
                            {is_main && item.is_send && <>
                                {item.status === 2 && <>
                                    <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                            onClick={() => toEdit(item)}/>
                                    {/* Foydalanuvchiga shu davr uchun qayta hisobot yuborish ruxsati */}
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        endIcon={<LockOpenIcon/>}
                                        title={t('allow_resubmit')}
                                        onClick={() => allowResubmit(item)}
                                        style={{minWidth: 'auto'}}
                                    />
                                </>}
                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                        onClick={() => toDelete(item)}/>
                            </>}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        )
    }

    return <div>
        <div className={'page'}>
            {open ? <DeleteModal setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <div className={'worker-page'}>
                        <div className={'header-page'}>
                            <h2 className={'page-title'}>{t('reports')}</h2>
                            {!is_main && (
                                <Button variant="contained" endIcon={<AddIcon/>} onClick={toAdd}>
                                    {t('add_report')}
                                </Button>
                            )}
                        </div>
                        <div className={'filter-block'}>
                            <form onSubmit={ToFilter}>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                    <span>{t('report_year')}:</span>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            minDate={new Date("2022-01-01")}
                                            views={['year']}
                                            label={t('report_year')}
                                            value={year}
                                            onChange={(newValue) => {
                                                setYear(new Date(newValue).getFullYear().toString())
                                            }}
                                            renderInput={(params) => <TextField {...params}/>}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                    <span>{t('report_month')}:</span>
                                    <Box sx={{minWidth: 200}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="month-label">{t('report_month')}</InputLabel>
                                            <Select labelId="month-label" value={month} label={t('report_month')}
                                                    onChange={(e) => setMonth(e.target.value)}>
                                                <MenuItem value={1}>{t('quarter')}</MenuItem>
                                                <MenuItem value={2}>{t('semi_annual')}</MenuItem>
                                                <MenuItem value={3}>{t('nine_month')}</MenuItem>
                                                <MenuItem value={4}>{t('yearly')}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </div>
                                <Button type={'submit'} className={'filter-btn'} variant="contained"
                                        color="primary">{t('filter')}</Button>
                            </form>
                            {is_main && !regionId && (
                                <div style={{marginTop: '10px'}}>
                                    <FormControl variant="outlined" style={{minWidth: 300}}>
                                        <InputLabel htmlFor="search-company">{t('search_company')}</InputLabel>
                                        <OutlinedInput
                                            id="search-company" value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                            label={t('search_company')}/>
                                    </FormControl>
                                </div>
                            )}
                        </div>
                        <TabContext value={tab}>
                            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                                <TabList onChange={(e, val) => { setTab(val) }}>
                                    <Tab value="one" label={t('no_send')}/>
                                    <Tab value="two" label={t('review')}/>
                                    <Tab value="three" label={t('canceled')}/>
                                    <Tab value="four" label={t('accepted')}/>
                                </TabList>
                            </Box>
                            <TabPanel value="one">
                                <ReportTable statusFilter={1}/>
                                {is_main && tab !== 'one' && (
                                    <Button onClick={saveFile} variant="contained" color="primary">
                                        {t('download_reports')}
                                    </Button>
                                )}
                            </TabPanel>
                            <TabPanel value="two">
                                <ReportTable statusFilter={2}/>
                                {is_main && tab !== 'one' && (
                                    <Button onClick={saveFile} variant="contained" color="primary">
                                        {t('download_reports')}
                                    </Button>
                                )}
                            </TabPanel>
                            <TabPanel value="three">
                                <ReportTable statusFilter={3}/>
                                {is_main && tab !== 'one' && (
                                    <Button onClick={saveFile} variant="contained" color="primary">
                                        {t('download_reports')}
                                    </Button>
                                )}
                            </TabPanel>
                            <TabPanel value="four">
                                <ReportTable statusFilter={4}/>
                                {is_main && tab !== 'one' && (
                                    <Button onClick={saveFile} variant="contained" color="primary">
                                        {t('download_reports')}
                                    </Button>
                                )}
                            </TabPanel>
                        </TabContext>
                        {props.total_pages > 1 && (
                            <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0'}}>
                                <Pagination count={props.total_pages} page={page}
                                            onChange={handlePageChange} color="primary" shape="rounded"/>
                            </div>
                        )}
                    </div>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.report, {
    getReports, deleteReport, editSaveReport, getAllVerifyResponse, messageReset, clearReports
})(Reports)